export const discountPaths = {
  DISCOUNT: "",
  DISCOUNT_CREATE: "create",
  DISCOUNT_EDIT: ":id",
  DISCOUNT_ID: (id) => `${id}`,
};
